import { axios } from '../http/axios';
import { TcccWebsocket } from '../socket/tcccWebsocket';

const prependSchema = (str: unknown) => {
  if (typeof str === 'string') {
    return str.replace(/^(http|ws)(s)?:\/\//, '');
  }
  return '';
};
export const isTestEnv = ['development', 'test'].includes(process.env.NODE_ENV as string);
const isUnderComCNDomain = window.location.hostname?.endsWith('tencent.com.cn');
const isUnderCNDomain = window.location.hostname?.endsWith('tencent.cn');
const isUniversalDomain = window.location.hostname?.endsWith('tencentcloud.com');
const baseDomain = (() => {
  if (isUnderCNDomain) {
    return 'api.ccc.cloud.tencent.cn';
  }
  if (isUnderComCNDomain) {
    return 'api.ccc.cloud.tencent.com.cn';
  }
  if (isUniversalDomain) {
    if (window.location.hostname === 'frankfurt.connect.tencentcloud.com')
      return 'frankfurt-api.connect.tencentcloud.com';
    return 'api.connect.tencentcloud.com';
  }
  return 'api.tccc.qcloud.com';
})();
const backupDomain = (() => {
  if (isUnderCNDomain || isUnderComCNDomain || isUniversalDomain) {
    return '';
  }
  return 'api-bak.tccc.qcloud.com';
})();

export const urlConfig = {
  tcccLogicUrl: `https://${prependSchema(baseDomain)}`,
  tcccStateUrl: `wss://${prependSchema(baseDomain)}/staff`,
  backupURL: backupDomain ? `https://${prependSchema(baseDomain)}` : '',
  backupLogicURL: backupDomain ? `wss://${prependSchema(baseDomain)}/staff` : '',
};
export function setUrlConfig(params: Partial<typeof urlConfig>) {
  Object.assign(urlConfig, params);
  Object.assign(axios.defaults, {
    baseURL: urlConfig.tcccLogicUrl,
    backupURL: urlConfig.backupURL,
  });
  TcccWebsocket.setProxy({
    url: `wss://${prependSchema(urlConfig.tcccStateUrl)}`,
    backupUrl: `wss://${prependSchema(urlConfig.backupLogicURL || urlConfig.tcccStateUrl)}`,
  });
}

export function getUrlConfig() {
  return urlConfig;
}
